/**
 * MeSH WP Theme - AccessibleWP RGAA accessibility fixes
 * Motif de conception modale : attributs ARIA injectés via JS,
 * focus trap, gestion du focus, ESC.
 */

( function () {
	'use strict';

	var toolbar    = document.getElementById( 'acwp-toolbar' );
	var triggerBtn = document.getElementById( 'acwp-toolbar-btn' );
	var closeBtn   = document.getElementById( 'acwp-close-toolbar' );

	if ( ! toolbar || ! triggerBtn ) return;

	// ---- Injection des attributs ARIA (évite l'override PHP du plugin) ----
	toolbar.setAttribute( 'role', 'dialog' );
	toolbar.setAttribute( 'aria-modal', 'true' );
	toolbar.setAttribute( 'aria-hidden', 'true' );

	// aria-labelledby : on ajoute un id sur le titre s'il n'en a pas
	var titleEl = toolbar.querySelector( '.acwp-title' );
	if ( titleEl ) {
		if ( ! titleEl.id ) {
			titleEl.id = 'acwp-toolbar-title';
		}
		toolbar.setAttribute( 'aria-labelledby', titleEl.id );
	}

	triggerBtn.setAttribute( 'aria-expanded', 'false' );
	triggerBtn.setAttribute( 'aria-controls', 'acwp-toolbar' );

	// -----------------------------------------------------------------------

	var lastFocus = null;

	var FOCUSABLE_SELECTOR = [
		'button:not([disabled])',
		'[href]',
		'input:not([disabled]):not([type="hidden"])',
		'select:not([disabled])',
		'textarea:not([disabled])',
		'[tabindex]:not([tabindex="-1"])',
	].join( ', ' );

	function getFocusableElements() {
		return Array.prototype.slice.call(
			toolbar.querySelectorAll( FOCUSABLE_SELECTOR )
		).filter( function ( el ) {
			return el.offsetParent !== null;
		} );
	}

	function onOpen() {
		toolbar.setAttribute( 'aria-hidden', 'false' );
		triggerBtn.setAttribute( 'aria-expanded', 'true' );
		lastFocus = document.activeElement;
		var focusable = getFocusableElements();
		if ( focusable.length ) {
			focusable[ 0 ].focus();
		}
	}

	function onClose() {
		toolbar.setAttribute( 'aria-hidden', 'true' );
		triggerBtn.setAttribute( 'aria-expanded', 'false' );
		if ( lastFocus ) {
			lastFocus.focus();
		}
	}

	// Observe l'ajout/retrait de la classe acwp-toolbar-show par le plugin
	var observer = new MutationObserver( function ( mutations ) {
		mutations.forEach( function ( mutation ) {
			if ( mutation.type === 'attributes' && mutation.attributeName === 'class' ) {
				if ( toolbar.classList.contains( 'acwp-toolbar-show' ) ) {
					onOpen();
				} else {
					onClose();
				}
			}
		} );
	} );

	observer.observe( toolbar, { attributes: true } );

	// Touche Échap : ferme la fenêtre
	toolbar.addEventListener( 'keydown', function ( e ) {
		if ( e.key === 'Escape' ) {
			if ( closeBtn ) {
				closeBtn.click();
			} else {
				triggerBtn.click();
			}
		}
	} );

	// Focus trap : garde le focus dans la modale tant qu'elle est ouverte
	toolbar.addEventListener( 'keydown', function ( e ) {
		if ( e.key !== 'Tab' ) return;
		if ( toolbar.getAttribute( 'aria-hidden' ) === 'true' ) return;

		var focusable = getFocusableElements();
		if ( ! focusable.length ) return;

		var first = focusable[ 0 ];
		var last  = focusable[ focusable.length - 1 ];

		if ( e.shiftKey ) {
			if ( document.activeElement === first ) {
				e.preventDefault();
				last.focus();
			}
		} else {
			if ( document.activeElement === last ) {
				e.preventDefault();
				first.focus();
			}
		}
	} );

} )();
